import LockSystem from "./LockSystem";
import OrderLockSystem from "./OrderLockSystem";
import { OrderType } from "../orderType";

export interface IOrder {
  orderID: number;
  safeKeyAppOrderID: string;
  companyID: number;
  ccid: string;
  sapOrderID: number;
  sapOrderNumber: string;
  sapOrderDate: string | null;
  sapLineNumber: string;
  orderPONumber: string;
  comments: string;
  orderSystemName: string;
  orderType: number;
  totalPrice: number;
  reviewPassCode: string;
  orderStatus: number;
  currency: string;
  salesArea: number;
  orderLockSystems: Array<any>;
  lockSystems: Array<any>;
}

export default class Order implements IOrder {
  constructor(
    public orderID: number = 0,
    public safeKeyAppOrderID: string = "",
    public companyID: number = 0,
    public ccid: string = "",
    public sapOrderID: number = 0,
    public sapOrderNumber: string = "",
    public sapOrderDate: string | null = null,
    public sapLineNumber: string = "",
    public orderPONumber: string = "",
    public comments: string = "",
    public orderSystemName: string = "",
    public orderType: number = OrderType.Order,
    public totalPrice: number = 0,
    public reviewPassCode: string = "",
    public orderStatus: number = 0,
    public currency: string = "",
    public salesArea: number = 0,
    public orderLockSystems: Array<OrderLockSystem> = [],
    public lockSystems: Array<LockSystem> = []
  ) {}

  /**
   *
   * @param input
   * @returns
   */
  static deserialize(input: Object): Order {
    return input as IOrder;
  }
}
